// Product photos are stored as large PNG/JPG files (often 3-5 MB each). Supabase's image
// endpoint serves the same signed file converted to WebP, about 8x lighter, with the same token.
// Public pages read the catalog through it; the admin keeps the original URLs so nothing
// rewritten is ever saved back to the database.

const SIGNED_IMAGE = /\/storage\/v1\/object\/sign\/([^"?\s\\]+\.(?:png|jpe?g))\?/gi;

export function lightImageUrl(url) {
    if (typeof url !== 'string') return url;
    return url.replace(SIGNED_IMAGE, '/storage/v1/render/image/sign/$1?');
}

export async function fetchWithLightImages(input, init = {}) {
    const response = await fetch(input, init);
    const url = typeof input === 'string' ? input : input.url;
    const method = (init.method || 'GET').toUpperCase();
    const isAdmin = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');

    if (isAdmin || method !== 'GET' || !url.includes('/rest/v1/') || !response.ok || response.status === 204) {
        return response;
    }

    const text = await response.text();
    const headers = new Headers(response.headers);
    headers.delete('content-length');
    headers.delete('content-encoding');
    return new Response(lightImageUrl(text), { status: response.status, statusText: response.statusText, headers });
}
